module.exports = __webpack_public_path__ + "img/gc-avatar.629c415f.png";